import { ActionTree } from 'vuex';
import { GlobalState } from '../types';
import { AuthState } from './types';

import Auth from '@aws-amplify/auth';
import Amplify from '@aws-amplify/core';

export const actions: ActionTree<AuthState, GlobalState> = {
    // configure the auth store
    init: ({ commit, dispatch }, config) => {
        if (![
            'userPoolId',
            'identityPoolId',
            'userPoolWebClientId',
            'region'
        ].every(opt => Boolean(config[opt]))) {
            throw new Error('userPoolId, identityPoolId, userPoolWebClientId and region are required in the config object.')
        }

        Amplify.configure({ Auth: config });

        // setup refresh every 10 minutes
        setInterval(async () => {
            await dispatch("refresh", { force: false });
        }, 300000);
    },

    // restore the local storage
    restore: ({ commit }) => {
        return new Promise((resolve, reject) => {
            Auth.currentSession().then(session => {
              console.log('restore session', session);
              Auth.currentUserPoolUser()
                .then(user => {

                  commit('setRestored', user);
                  resolve(session);
                }).catch(reject);
            }).catch((err) => {
                console.log('restore session err', err);
                reject(err);
            });
        });
    },

    refresh: ({ commit }) => {
        return new Promise((resolve, reject) => {
            Auth.currentSession().then(session => {
              Auth.currentUserPoolUser()
                .then(user => {
                  commit('setRestored', user);
                  resolve();
                }).catch((err) => {
                    console.log('refresh session err', err);
                    resolve();
                });
            }).catch((err) => {
                console.log('refresh session err', err);
                resolve();
            });
        });
    },

    signIn: ({ commit }, credentials) =>
        new Promise((resolve, reject) => {
            Auth.signIn(credentials.email, credentials.password)
            .then((user) => {
                if (user.challengeName == 'NEW_PASSWORD_REQUIRED') {
                    commit('setNeedsPassword', user);
                } else {
                    commit('setAuthenticated', user);
                }
                resolve(user)
            }).catch(reject)
    }),

    signOut: ({ commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            if (!getters.isAuthenticated) {
                reject(new Error('User not logged in.'));
                return;
            }
            Auth.signOut()
              .then(result => {
                commit('setSignedOut');

                resolve(result)
              })
              .catch(reject);
        });
    },

    forgotPassword: ({ commit }, payload) =>
        new Promise((resolve, reject) => {
        Auth.forgotPassword(payload.email)
            .then(response => {
                commit('resetRequested', {
                    email: payload.email,
                    response
                });
                resolve(response);
            })
            .catch(reject)
    }),

    changeTempPassword: ({ commit, state }, payload) => {
        return new Promise((resolve, reject) => {
            if (state.user == null)  {
                reject("Must have a user");
                return;
            }
            console.log('change temp password');
            state.user.completeNewPasswordChallenge(payload.newPassword, null, {
                onSuccess: (session) => {
                    Auth.currentUserPoolUser()
                        .then(user => {
                            commit('setAuthenticated', user)
                            resolve(user)
                        }).catch(reject);
                },
                onFailure: (err) => {
                    reject(err);
                }
            })
        })
    },

    resetPassword: ({ commit, state }, data) =>
        new Promise((resolve, reject) => {
            Auth.forgotPasswordSubmit(
                state.lastForgot || "",
                data.code,
                data.newPassword
            )
            .then(response => {
                commit('passwordReset', response);
                resolve();
            })
            .catch(reject);
    }),
};
